
import { Prop, Vue } from 'vue-property-decorator';
import TestController from '../../controllers/TestController';
import { inject } from 'vue';
import EventBusConstants from '../../constants/EventBusConstants';
import NavigationDirectionEnum from '../../controllers/navigation/NavigationDirectionEnum';
import PlayerEmitter from '../../event/PlayerEmitter';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';

export default class BasicNavigationControl extends Vue {
  private sectionLockEnabled = false;
  private showReviewScreen = true;

  @Prop() readonly previousButtonText: string | undefined;
  @Prop() readonly nextButtonText: string | undefined;
  @Prop({ default: false }) readonly useSubmitIcon: boolean | undefined;
  @Prop({ default: false }) readonly rightAlign: boolean | undefined;
  @Prop({ default: '#f8f9fa' }) readonly previousButtonColor: string | undefined;

  private testController: TestController | undefined = inject<TestController>('testController');

  private playerEmitter: PlayerEmitter | undefined = inject<PlayerEmitter>('playerEmitter');

  get previousEnabled(): boolean {
    if (
      this.testController &&
      this.testController.navigationController &&
      this.testController.navigationController.navigationContext
    ) {
      return (
        this.testController.navigationController.previousAvailable() ||
        this.testController.navigationController.navigationContext.navigationStateIsReviewScreen()
      );
    } else {
      return false;
    }
  }

  private get containerStyle(): string {
    let style = 'margin-left: 15px;';
    if (this.rightAlign) {
      style = 'margin-left: auto;';
    }
    style += 'background-color: ' + this.previousButtonColor;
    return style;
  }

  private getIconBeforeNext(): string {
    return this.useSubmitIcon ? 'fa mr-2 fa-check' : '';
  }

  private getIconAfterNext(): string {
    return !this.useSubmitIcon ? 'fa fa-arrow-right' : '';
  }

  mounted() {
    this.sectionLockEnabled = this.testController
      ? this.testController.deliveryOptionEnabledForTest(DeliveryOptionConstants.BLOCK_RETURN_TO_SECTION)
      : false;

    this.showReviewScreen = this.testController
      ? this.testController.deliveryOptionEnabledForTest(DeliveryOptionConstants.FINAL_REVIEW_SCREEN)
      : true;
  }

  private previousButtonDisplayText(): string {
    let value = this.previousButtonText;
    if (value === undefined) {
      value = this.$t('btn.previous');
    }
    return value;
  }

  private nextButtonDisplayText(): string {
    let value = this.nextButtonText;
    if (value === undefined) {
      if (this.testController!.navigationController?.endOfTest() && !this.sectionLockEnabled && this.showReviewScreen) {
        value = this.$t('btn.review_assessment');
      } else if (this.testController!.navigationController?.endOfSection()) {
        if (this.showReviewScreen) {
          value = this.$t('btn.review') + ' ' + this.testController?.navigationController.getCurrentItem()?.section.title;
        } else {
          const nextItem = this.testController?.navigationController.peekNextItem();
          if (nextItem) {
            value = this.$t('btn.continue_to')  + ' ' + nextItem.section.title;
          } else {
            value = this.$t('modal.submit_header');
          }
        }
      }
    }

    if (value === undefined) {
      value = this.$t('btn.next');
    }

    return value;
  }

  private previousButtonClicked(): void {
    this.playerEmitter!.emit(EventBusConstants.NAVIGATION_EVENT, [['direction', NavigationDirectionEnum.Back]]);
  }

  private nextButtonClicked(): void {
    this.playerEmitter!.emit(EventBusConstants.NAVIGATION_EVENT, [['direction', NavigationDirectionEnum.Forward]]);
  }
}
